import { css } from '@emotion/react';
import { Box } from '@mui/system';

const style = {
  red_card: (theme: any) => css`
    background-color: ${theme.vars.palette.error.main};
    color: white;
  `,
  yellow_card: (theme: any) => css`
    background-color: ${theme.vars.palette.premium.main};
  `,
  white_card: (theme: any) => css`
    background-color: ${theme.vars.palette.background.default};
    color: ${theme.vars.palette.primary.main};
  `,
  blue_card: (theme: any) => css`
    background-color: ${theme.vars.palette.primary.main};
    color: white;
  `,
  scoreSmall: css`
    font-size: 0.6rem;
  `,
  scoreXSmall: css`
    font-size: 0.4rem;
  `,
};

type CardProps = {
  count: number;
  actionType: 'yellow_card' | 'red_card' | 'white_card' | 'blue_card';
};

export const Card = ({ count, actionType }: CardProps) => {
  if (!count || count === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '3px',
        textAlign: 'center',
        width: '1rem',
        height: '1.5rem',
        fontSize: '0.8rem',
        margin: '0',
        color: 'primary.main',
        mb: 0.5,
      }}
      css={[
        style[actionType],
        count >= 10 && style.scoreSmall,
        count >= 100 && style.scoreXSmall,
      ]}
    >
      {count}
    </Box>
  );
};
